module.exports = __webpack_public_path__ + "img/question15c3.e66867bf.png";